// extracted by mini-css-extract-plugin
export default {"button":"Download_button__SOPj5"};